import React from 'react';
import { FormattedMessage } from 'react-intl';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';

export const DAYS_OLD_DATA = 14;

interface WarningForOldTimestampProps {
    timestamp?: string | number | Date;
}

const isOldData = (timestamp: string | number | Date, daysOldData = DAYS_OLD_DATA): boolean => {
    const now = new Date();
    const cutoffDate = new Date(now.getTime() - daysOldData * 24 * 60 * 60 * 1000);
    return new Date(timestamp) < cutoffDate;
};

export const WarningForOldTimestamp: React.FC<WarningForOldTimestampProps> = ({ timestamp }) => {
    if (!timestamp || !isOldData(timestamp)) {
        return null;
    }

    const tooltip = (
        <Tooltip id={`warning-${Date.now()}`}>
            <FormattedMessage
                id="intl-msg:vehicle-diagnostics.dataTimestamp.olderThanXDays"
                values={{ days: DAYS_OLD_DATA }}
            />
        </Tooltip>
    );

    return (
        <>
            &nbsp;
            <OverlayTrigger overlay={tooltip}>
                {/* eslint-disable-next-line max-len */}
                <span className="rioglyph rioglyph-exclamation-sign text-color-dark text-size-16 width-auto margin-top-0" />
            </OverlayTrigger>
        </>
    );
};

export default WarningForOldTimestamp;
